export default __webpack_public_path__ + "static/media/plus-icon.a8fad2ff.svg";